export type { ResetPassword, ResetPasswordFailure } from './reset-password';
export {
	RESET_PASSWORD,
	RESET_PASSWORD_FAILURE,
	resetPassword,
	resetPasswordFailure,
} from './reset-password';
